import { render, staticRenderFns } from "./ConfirmToken.vue?vue&type=template&id=5fd8a7fa&"
import script from "./ConfirmToken.vue?vue&type=script&lang=js&"
export * from "./ConfirmToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports